import {
  IconBank,
  IconCalendar,
  IconCreditCard,
  IconDollar,
  IconEdit,
  IconFileText,
  IconHashtag,
  IconHomeDash,
  IconLocation,
  IconLock,
  IconMessage,
  IconPhoneCall,
  IconPhonePlus,
  IconSwitch,
  IconUserPlusBottom,
  IconUserViewfinder,
} from '../../../utils/icons'
import { SafetyOutlined } from '@ant-design/icons'

export const formIcons = {
  'home': IconHomeDash,
  'user-plus': IconUserPlusBottom,
  'user': IconUserViewfinder,
  'bank': IconBank,
  'lock': IconLock,
  'calendar': IconCalendar,
  'phone': IconPhoneCall,
  'hash-tag': IconHashtag,
  'point': IconLocation,
  'phone-in': IconPhonePlus,
  'message': IconMessage,
  'switch': IconSwitch,
  'dollar': IconDollar,
  'file-text': IconFileText,
  'card': IconCreditCard,
  'edit': IconEdit,
  'id': SafetyOutlined
} as const;

export type IFormIconName = keyof typeof formIcons;
